import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import * as Exchange from 'exchange/components/form';

const ExchangeFormView = ({
  coins,
  company,
  exchange,
  handleSubmit,
  handleValidation,
  handleValueChange,
  isFetching,
  isSubmitted,
  isSaving,
  t,
}) => (
  <Common.Wrapper fluid={true}>
    <Common.Header title={t('exchange.exchange_title')} />
    <div className="col-12">
      <Common.Portlet title={t(exchange.id ? 'exchange.edit' : 'exchange.add')} icon={'archive'}>
        <Exchange.Form
          coins={coins}
          company={company}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          values={exchange}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(ExchangeFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/components/ExchangeFormView.js